<div class="dalog-header-cust">
    <h2>Change Password</h2>
    <button type="button" class="btn-cust-close" (click)="navService.openSideNav({ toogle: true })">
    <i class="icon-close"></i>
  </button>
</div>
<!-- <button class="btn-close" (click)="navService.openSideNav({ toogle: true })">
  <mat-icon>close</mat-icon>
</button>
<mat-toolbar class="mat-elevation-z0">
  <mat-toolbar-row>
    <div class="notificard">
      <h2>
        <img src="assets/images/request-a-call.svg" alt="" class="me-2" />
        CHNAGE PASSWORD
      </h2>
    </div>
  </mat-toolbar-row>
</mat-toolbar> -->
<div class="side-drawer-content request">
  <div [formGroup]="formGroup" class="px-3 py-1">
    <div class="col-lg-12 col-12">
      <label
        >Username @if (Global.isInputRuleAvailable(formGroup, 'userName',
        'required')) { <span class="text-danger">*</span>}
      </label>
      <mat-form-field class="w-100 cust-change-input">
        <input
          matInput
          [readonly]="true"
          formControlName="userName"
          [class.is-invalid]="!Global.isInputValid(formGroup, 'userName')"
          placeholder="Type Here"
        />
        @if (!Global.isInputRuleValid(formGroup, 'userName', 'required')) {
        <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-12 col-12">
      <label
        >Current Password @if (Global.isInputRuleAvailable(formGroup,
        'oldPassword', 'required')) { <span class="text-danger">*</span>}
      </label>
      <mat-form-field class="w-100">
        <input
          [type]="!hide[0] ? 'password' : 'text'"
          matInput
          formControlName="oldPassword"
          [class.is-invalid]="!Global.isInputValid(formGroup, 'oldPassword')"
          placeholder="Type Here"
        />
        <button
          mat-icon-button
          matSuffix
          (click)="hide[0] = !hide[0]"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide[0]"
        >
          <mat-icon>{{ !hide[0] ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
        @if (!Global.isInputRuleValid(formGroup, 'oldPassword', 'required')) {
        <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-12 col-12">
      <label
        >New Password @if (Global.isInputRuleAvailable(formGroup, 'newPassword',
        'required')) { <span class="text-danger">*</span>}
      </label>
      <mat-form-field class="w-100">
        <input
          [type]="!hide[1] ? 'password' : 'text'"
          matInput
          formControlName="newPassword"
          [class.is-invalid]="!Global.isInputValid(formGroup, 'newPassword')"
          placeholder="Type Here"
        />
        <button
          mat-icon-button
          matSuffix
          (click)="hide[1] = !hide[1]"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide[1]"
        >
          <mat-icon>{{ !hide[1] ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
        @if (!Global.isInputRuleValid(formGroup, 'newPassword', 'required')) {
        <mat-error>This field is required</mat-error>
        } @if (!Global.isInputRuleValid(formGroup, 'newPassword', 'minlength'))
        {
        <mat-error>Minimum 8 characters required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-12 col-12">
      <label
        >Confirm Password @if (Global.isInputRuleAvailable(formGroup,
        'confirmPassword', 'required')) { <span class="text-danger">*</span>}
      </label>
      <mat-form-field class="w-100">
        <input
          [type]="!hide[2] ? 'password' : 'text'"
          matInput
          formControlName="confirmPassword"
          [class.is-invalid]="
            !Global.isInputValid(formGroup, 'confirmPassword')
          "
          placeholder="Type Here"
        />
        <button
          mat-icon-button
          matSuffix
          (click)="hide[2] = !hide[2]"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide[2]"
        >
          <mat-icon>{{ !hide[2] ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
        @if (!Global.isInputRuleValid(formGroup, 'confirmPassword', 'required'))
        {
        <mat-error>This field is required</mat-error>
        } @if (formGroup.controls['confirmPassword'].errors?.['mustMatch']) {
        <mat-error>Confirm Password must match</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="p-3">
    <button
      type="button"
      class="btn btn-primary w-100"
      (click)="onSubmit($event)"
    >
      <span class="indicator-label"> Update Password</span>
      <span class="indicator-progress"
        >Please wait...
        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </span>
    </button>
  </div>
</div>
